import UnitOnlineUsage from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'unitNo':
      return [key, `${val}`]; // stringify
    default:
      return [key, val];
  }
};

const create = (data) =>
  new UnitOnlineUsage(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/OnlineUsage/UnitOnlineUsage/create.js